<script>
export default {
  props: ["clr"]
};
</script>
<template>
  <svg
    id="document-legal-users"
    xmlns="http://www.w3.org/2000/svg"
    width="28"
    height="28"
    viewBox="0 0 28 28"
  >
    <path id="Path_8066" data-name="Path 8066" d="M0,0H28V28H0Z" fill="none" />
    <path
      id="Path_8067"
      data-name="Path 8067"
      d="M3,19H3a2.333,2.333,0,0,0,2.333,2.333"
      transform="translate(0.5 3.167)"
      fill="none"
      :stroke="clr ? clr : '#500fe9'"
      stroke-linecap="round"
      stroke-linejoin="round"
      stroke-width="2"
    />
    <path
      id="Path_8068"
      data-name="Path 8068"
      d="M3,5V21.333"
      transform="translate(0.5 0.833)"
      fill="none"
      :stroke="clr ? clr : '#500fe9'"
      stroke-linecap="round"
      stroke-linejoin="round"
      stroke-width="2"
    />
    <path
      id="Path_8069"
      data-name="Path 8069"
      d="M9.667,21H5"
      transform="translate(0.833 3.5)"
      fill="none"
      :stroke="clr ? clr : '#500fe9'"
      stroke-linecap="round"
      stroke-linejoin="round"
      stroke-width="2"
    />
    <path
      id="Path_8070"
      data-name="Path 8070"
      d="M21.333,5.333h0A2.333,2.333,0,0,0,19,3"
      transform="translate(3.167 0.5)"
      fill="none"
      :stroke="clr ? clr : '#500fe9'"
      stroke-linecap="round"
      stroke-linejoin="round"
      stroke-width="2"
    />
    <path
      id="Path_8071"
      data-name="Path 8071"
      d="M21,8.5V5"
      transform="translate(3.5 0.833)"
      fill="none"
      :stroke="clr ? clr : '#500fe9'"
      stroke-linecap="round"
      stroke-linejoin="round"
      stroke-width="2"
    />
    <path
      id="Path_8072"
      data-name="Path 8072"
      d="M5,3H21.333"
      transform="translate(0.833 0.5)"
      fill="none"
      :stroke="clr ? clr : '#500fe9'"
      stroke-linecap="round"
      stroke-linejoin="round"
      stroke-width="2"
    />
    <path
      id="Path_8073"
      data-name="Path 8073"
      d="M3,5.333H3A2.333,2.333,0,0,1,5.333,3"
      transform="translate(0.5 0.5)"
      fill="none"
      :stroke="clr ? clr : '#500fe9'"
      stroke-linecap="round"
      stroke-linejoin="round"
      stroke-width="2"
    />
    <path
      id="Path_8074"
      data-name="Path 8074"
      d="M8.75,17.562h0A1.75,1.75,0,0,1,7,15.812H7a1.75,1.75,0,0,1,1.75-1.75h0a1.75,1.75,0,0,1,1.75,1.75h0A1.75,1.75,0,0,1,8.75,17.562Z"
      transform="translate(1.167 2.344)"
      fill="none"
      :stroke="clr ? clr : '#500fe9'"
      stroke-linecap="round"
      stroke-linejoin="round"
      stroke-width="2"
    />
    <path
      id="Path_8075"
      data-name="Path 8075"
      d="M7,7.062h9.333"
      transform="translate(1.167 1.177)"
      fill="none"
      :stroke="clr ? clr : '#500fe9'"
      stroke-linecap="round"
      stroke-linejoin="round"
      stroke-width="2"
    />
    <path
      id="Path_8076"
      data-name="Path 8076"
      d="M7,10.562h5.833"
      transform="translate(1.167 1.76)"
      fill="none"
      :stroke="clr ? clr : '#500fe9'"
      stroke-linecap="round"
      stroke-linejoin="round"
      stroke-width="2"
    />
    <path
      id="Path_8077"
      data-name="Path 8077"
      d="M13.5,20.917v-.474h0A2.45,2.45,0,0,1,15.943,18h3.864a2.45,2.45,0,0,1,2.443,2.443v.474h0a.583.583,0,0,1-.583.583H14.083a.583.583,0,0,1-.583-.583h0Z"
      transform="translate(2.25 3)"
      fill="none"
      :stroke="clr ? clr : '#500fe9'"
      stroke-linecap="round"
      stroke-linejoin="round"
      stroke-width="2"
    />
    <path
      id="Path_8078"
      data-name="Path 8078"
      d="M15.25,13.824h0a2.333,2.333,0,1,1,2.333,2.343h0a2.333,2.333,0,0,1-2.333-2.333s0-.006,0-.009Z"
      transform="translate(2.542 1.917)"
      fill="none"
      :stroke="clr ? clr : '#500fe9'"
      stroke-linecap="round"
      stroke-linejoin="round"
      stroke-width="2"
    />
  </svg>
</template>
